import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getChildOuData } from 'redux/slices/getChildOu';
import { getDomainData } from 'redux/slices/domainSlice';
import {
  setExpandedKeysAdmin,
  fetchTreeData,
  getChildOuTreeData,
  setAdminTree,
  updateChildrenInTree,
  setNodekey,
} from 'redux/slices/treedata';
import {
  setDomainDn,
  setDomainId,
  setDomainName,
  setSelectedNode,
  setTypeOfData,
} from 'redux/slices/selectedNodeSlice';
import { FolderOpenIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { AntTree } from './style';
import { getAllUsers } from 'redux/slices/userSlice';
import { getOuGroupData } from 'redux/slices/getOuGroups';
import { useLocation } from 'react-router-dom/dist';
import {
  getDomainExportAttribute,
  getDomainSettingPageDetails,
  getOverrideGlobalStatus,
} from 'redux/slices/settingsSlice';

const AdminTree = () => {
  // const { TreeNode } = Tree;
  const dispatch = useDispatch();
  const location = useLocation();
  const domain = localStorage.getItem('domain');
  const { domainObject } = useSelector((state) => state.domainData);
  const userLoading = useSelector((state) => state.getUsers.loading);
  const groupLoading = useSelector((state) => state.getOuGroupData.loading);
  const ouLoading = useSelector((state) => state.getChildOuData.loading);
  const { adminTreeExpandedKeys, adminTree } = useSelector((state) => state.treeData);
  const fqdn = useSelector((state) => state.selectedNode.domainName); //fqdn is a domain name
  const selectedNode = useSelector((state) => state.selectedNode);
  const { pageGroupNumber, pageGroupSize, groupSearch, groupIsDescending, groupSortType } = useSelector(
    (state) => state.getOuGroupData
  );
  const { pageOuNumber, pageOuSize, ouSearch, ouIsDescending, ouSortType } = useSelector(
    (state) => state.getChildOuData
  );
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);
  const [prevSelectedNode, setPrevSelectedNode] = useState(selectedNode);

  /*  if we want custom icons for treeNode use this function

 const customSwitcherIcon = ({ loading, expanded }) => {
    if (loading) {
      return <LoadingOutlined style={{ fontSize: '20px', color: 'red' }} />;
    }
    if (expanded) {
      return <MinusCircleFilled style={{ fontSize: '16px', color: 'white' }} />;
    }
    return <PlusCircleFilled style={{ fontSize: '16px', color: 'white' }} />;
  }; */

  const getNodeTitle = (node) => {
    const isSelected = selectedNodeKey === node.key;
    return (
      <span
        style={{
          color: isSelected ? 'var(--leftmenu-active-color)' : 'var(--leftmenu-text-color)',
          whiteSpace: 'nowrap',
          backgroundColor: isSelected ? 'var(--leftmenu-highlighter-color)' : 'transparent',
          borderRadius: '6px',
          padding: isSelected && '4px 12px 5px 12px',
        }}
      >
        {node.isLeaf && !node.builtin && <FolderOpenIcon />}
        &nbsp;
        {node.title}
      </span>
    );
  };

  const handleNodeSelect = async (selectedKeys, info) => {
    if (userLoading || ouLoading || groupLoading) return;
    setSelectedNodeKey(selectedKeys[0]);
    if (info.node.key.includes('-')) {
      const nodeKeySplit = info.node?.key?.split('-');
      const currentDomain = adminTree.find((ele) => Number(ele.id) === Number(nodeKeySplit[0]));
      dispatch(setDomainDn(currentDomain.dnName));
      dispatch(setDomainId(currentDomain.id));
      dispatch(setDomainName(currentDomain.name));
      if (selectedKeys.length > 0) {
        const selectedNodeInfo = info.node;
        const selectedNodeData = {
          name: selectedNodeInfo.title,
          dnName: selectedNodeInfo.dnName,
        };
        dispatch(setSelectedNode(selectedNodeData));
        dispatch(setNodekey(selectedNodeInfo.key));
        if (info.node.isLeaf && !info.node.builtin) {
          dispatch(setTypeOfData('container'));
        } else if (info.node.builtin) {
          dispatch(setTypeOfData('builtinDomain'));
        } else {
          const childData = await fetchChildData(selectedNodeInfo.dnName, selectedNodeInfo.key, currentDomain.name);
          if (childData.length === 0) {
            dispatch(setExpandedKeysAdmin([...adminTreeExpandedKeys, info.node.key]));
          }
          dispatch(setTypeOfData('ou'));
        }
      }
    } else {
      dispatch(setDomainName(info.node.title));
      dispatch(setDomainDn(info.node.dnName));
      dispatch(setDomainId(info.node.key));
      dispatch(getOverrideGlobalStatus(info.node.key));
      dispatch(setTypeOfData('domain'));
      dispatch(setNodekey(info.node.key));
      dispatch(setSelectedNode({ name: info.node.title, dnName: info.node.dnName }));
    }
  };
  useEffect(() => {
    dispatch(getDomainData());
  }, []);

  useEffect(() => {
    if (selectedNode.currentdomainId) {
      dispatch(getDomainSettingPageDetails(selectedNode.currentdomainId));
      dispatch(getDomainExportAttribute(selectedNode.currentdomainId));
    }
  }, [selectedNode.currentdomainId]);

  useEffect(() => {
    let updatedSearchQuery;
    let updatedPageNumber;
    let updatedPageSize;
    let updatedIsDescending;
    let updatedSortType;

    if (selectedNode.selectedNode !== prevSelectedNode.selectedNode) {
      updatedSearchQuery = '';
      updatedPageNumber = 1;
      updatedPageSize = 20;
      updatedIsDescending = false;
      updatedSortType = '';
    } else {
      if (location.pathname === '/') {
        updatedSearchQuery = selectedNode.searchQuery;
        updatedPageNumber = selectedNode.pageNumber;
        updatedPageSize = selectedNode.pageSize;
        updatedIsDescending = selectedNode.isDescending;
        updatedSortType = selectedNode.sortType;
      } else if (location.pathname === '/groupdata') {
        updatedSearchQuery = groupSearch;
        updatedPageNumber = pageGroupNumber;
        updatedPageSize = pageGroupSize;
        updatedIsDescending = groupIsDescending;
        updatedSortType = groupSortType;
      } else if (location.pathname === '/oudata') {
        updatedSearchQuery = ouSearch;
        updatedPageNumber = pageOuNumber;
        updatedPageSize = pageOuSize;
        updatedIsDescending = ouIsDescending;
        updatedSortType = ouSortType;
      }
    }
    const commonValues = {
      ouName:
        selectedNode.selectedNode && selectedNode.selectedNode.dnName
          ? selectedNode.selectedNode.dnName
          : localStorage.getItem('domainDn'),
      fqdn: selectedNode.domainName || localStorage.getItem('domain'),
      searchQuery: updatedSearchQuery,
      page: updatedPageNumber,
      pageSize: updatedPageSize,
      isDescending: updatedIsDescending,
      sortType: updatedSortType,
    };
    if (selectedNode.domainName && adminTree.length !== 0) {
      if (location.pathname === '/') {
        dispatch(getAllUsers({ ...commonValues, usersFilter: selectedNode.usersFilter }));
      } else if (location.pathname === '/groupdata') {
        dispatch(getOuGroupData(commonValues));
      } else if (location.pathname === '/oudata') {
        if (selectedNode.typeOfData !== 'container') {
          // dispatch(getOuComputersData(value)); // currently computer data is not required, may include in the future
          dispatch(getChildOuData(commonValues));
        }
      }
    }
    setPrevSelectedNode(selectedNode);
  }, [
    selectedNode.selectedNode,
    location.pathname,
    selectedNode.pageNumber,
    selectedNode.pageSize,
    selectedNode.isDescending,
    selectedNode.sortType,
    pageOuNumber,
    pageOuSize,
    ouIsDescending,
    ouSortType,
    pageGroupNumber,
    pageGroupSize,
    groupIsDescending,
    groupSortType,
  ]);

  useEffect(() => {
    if (domainObject && domainObject.length > 0) {
      const matchingDomain = domainObject.find((domainItem) => domainItem.name === domain);
      if (matchingDomain) {
        const nodeKey = matchingDomain.id.toString();
        setSelectedNodeKey(nodeKey);
        dispatch(setDomainName(matchingDomain.name));
        dispatch(setDomainId(matchingDomain.id));
        dispatch(getOverrideGlobalStatus(matchingDomain.id));
        dispatch(setDomainDn(matchingDomain.dnName));
        dispatch(setTypeOfData('domain'));
        dispatch(setNodekey(matchingDomain.id));
        dispatch(setSelectedNode({ name: matchingDomain.name, dnName: matchingDomain.dnName }));
      }
    }
  }, [domainObject, domain]);

  useEffect(() => {
    dispatch(setAdminTree(domainObject));
  }, [domainObject]);

  const fetchParentData = async (domainName, key) => {
    let count = 1;
    const parentfromApi = await dispatch(fetchTreeData(domainName));
    const data = parentfromApi.payload;
    if (!parentfromApi) {
      return [];
    }
    let initTreeData = [];
    if (data) {
      let builtins = [];
      let organizationalUnits = [];
      let containers = [];

      data.forEach((item) => {
        let obj = { name: '', id: '', dnName: '', isLeaf: false, builtin: false };
        if (item.role === 'builtinDomain') {
          obj.name = item.name;
          obj.dnName = item.distinguishedName;
          obj.id = `${key}-` + count++;
          obj.builtin = true;
          obj.isLeaf = true;
          builtins.push(obj);
        } else if (item.role === 'organizationalUnit') {
          obj.name = item.name;
          obj.dnName = item.distinguishedName;
          obj.id = `${key}-` + count++;
          organizationalUnits.push(obj);
        } else if (item.role === 'container') {
          obj.name = item.name;
          obj.dnName = item.distinguishedName;
          obj.id = `${key}-c-` + count++;
          obj.isLeaf = true;
          containers.push(obj);
        }
      });
      initTreeData = builtins.concat(organizationalUnits, containers);
    }
    return initTreeData;
  };

  const fetchChildData = async (parentName, key, domainFQDN = fqdn) => {
    const domainfqdn = {
      ouName: parentName,
      fqdn: domainFQDN,
    };
    const data = await dispatch(getChildOuTreeData(domainfqdn));
    let count = 1;
    if (data == null) {
      return null;
    }

    const childfromApi = data.payload.map((data) => {
      return {
        id: `${key}-` + count++,
        name: data.name,
        dnName: data.dnName,
      };
    });

    return childfromApi;
  };
  /*   commented this code may use in future
  const renderTreeNodes = (data) => {
    if (!data) {
      return null;
    }

    return data.map((node) => (
      <TreeNode title={node.name} key={node.id} hasChildren={node.hasChildren}>
        {node.children && renderTreeNodes(node.children)}
      </TreeNode>
    ));
  }; */

  const loadChildren = async (parent) => {
    const childData = await fetchChildData(parent.dnName, parent.id);
    const updatedChildren = childData.map((child) => ({
      id: child.id,
      dnName: child.dnName,
      name: child.name,
      hasChildren: true,
    }));
    const updatedAdminTree = updateChildrenInTree(adminTree, parent.id, updatedChildren);
    dispatch(setAdminTree(updatedAdminTree));
  };
  const loadParents = async (domain) => {
    dispatch(setNodekey(domain.id));
    dispatch(setDomainName(domain.name));
    const parentData = await fetchParentData(domain.name, domain.id);
    const updatedDomain = parentData.map((parent) => ({
      id: parent.id,
      dnName: parent.dnName,
      name: parent.name,
      builtin: parent.builtin,
      ...(parent.isLeaf ? { isLeaf: true } : { hasChildren: true }), // Conditionally set hasChildren,
    }));
    const updatedAdminTree = updateChildrenInTree(adminTree, domain.id, updatedDomain);
    dispatch(setAdminTree(updatedAdminTree));
  };

  const convertToTreeData = (data) => {
    if (!data) {
      return [];
    }
    return data.map((domain) => ({
      key: domain.id.toString(),
      title: domain.name.toLowerCase(),
      dnName: domain.dnName,
      isLeaf: domain.isLeaf, // Set isLeaf based on your data
      builtin: domain.builtin,
      children: domain.children ? convertToTreeData(domain.children) : [],
    }));
  };

  const findDomainById = (data, targetId, onMatch) => {
    for (const node of data) {
      if (node.id.toString() === targetId) {
        onMatch(node);
        return;
      }
      if (node.children) {
        findDomainById(node.children, targetId, onMatch);
      }
    }
  };

  const handleNodeExpand = (expandedKeys, { node }) => {
    if (userLoading || ouLoading || groupLoading) return;
    if (!node.key.includes('-')) {
      const nodeKey = node.key.toString();
      setSelectedNodeKey(nodeKey);
      dispatch(setNodekey(node.key));
      dispatch(setDomainId(node.key));
      dispatch(getOverrideGlobalStatus(node.key));
      dispatch(setSelectedNode({ name: node.title, dnName: node.dnName }));
    }

    const nodeKeySplit = node?.key?.split('-');
    // commented this code may use in future
    // const currentSelectedDomainTree = expandedKeys.filter(ele => ele?.split('-')[0] == nodeKeySplit[0]);
    let currentSelectedDomainTree = expandedKeys;
    if (expandedKeys.length === 0) {
      currentSelectedDomainTree = [];
    } else if (Number(expandedKeys[0].split('-')[0]) !== Number(nodeKeySplit[0])) {
      currentSelectedDomainTree = [node.key];
    }

    const currentDomain = adminTree.find((ele) => Number(ele.id) === Number(nodeKeySplit[0]));
    // const expandedParentName = node ? node.title : null;
    dispatch(setDomainName(currentDomain?.name));
    dispatch(setExpandedKeysAdmin(currentSelectedDomainTree));
  };

  const handleLoadData = async (treeNode) => {
    if (userLoading || ouLoading || groupLoading) return;
    const nodeKeySplit = treeNode?.key?.split('-');
    // commented this code may use in future
    // const currentSelectedDomainTree = expandedKeys.filter(ele => ele?.split('-')[0] == nodeKeySplit[0]);
    const currentDomain = adminTree.find((ele) => Number(ele.id) === Number(nodeKeySplit[0]));
    const clickedDomainId = treeNode.key;
    dispatch(setDomainName(currentDomain.name));
    const onMatch = (matchedNode) => {
      if (matchedNode.hasChildren) {
        loadChildren(matchedNode);
      } else {
        loadParents(matchedNode);
      }
    };

    findDomainById(adminTree, clickedDomainId, onMatch);
  };

  return (
    <AntTree
      showLine
      disabled={userLoading || ouLoading || groupLoading}
      loadData={handleLoadData}
      onSelect={handleNodeSelect}
      titleRender={getNodeTitle}
      onExpand={handleNodeExpand}
      expandedKeys={adminTreeExpandedKeys}
      treeData={adminTree ? convertToTreeData(adminTree) : []}
      className={userLoading || ouLoading || groupLoading ? 'tree-disabled af-admin-tree-wrap' : 'af-admin-tree-wrap'}
      // switcherIcon={customSwitcherIcon} //for icons
    >
      {/* {renderTreeNodes(domainData)}  commented this code may use in future*/}
    </AntTree>
  );
};

export default AdminTree;
